import { useEffect } from "react";

/**
 * Hands a chart's download spec to the report shell, which owns the Download
 * buttons: {title, legend: [{label, color}], dataRows: [[header...], [...]]}.
 * `getSpec` is read when the user clicks, so it always reflects what is drawn.
 */
export const useChartExport = (registerChartExport, getSpec) => {
  useEffect(() => {
    if (!registerChartExport) return undefined;
    registerChartExport(getSpec);
    return () => registerChartExport(null);
  }, [registerChartExport, getSpec]);
};
